var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { create } from "zustand";
import { channelOperation } from "../util/DataUtils";
const LOGPREFIX = "ChannelPostsStore: ";
export const useChannelPostsStore = create((set, get) => ({
    // Initial state
    postIds: [],
    isLoading: false,
    lastLoadTime: 0,
    error: undefined,
    channelOwnerId: undefined,
    channelId: undefined,
    // Load channel posts
    loadChannelPosts: (channelOwnerId, channelId, auth, cacheBusterStore, logger) => __awaiter(void 0, void 0, void 0, function* () {
        logger.log(LOGPREFIX + `Loading posts for channel ${channelOwnerId}/${channelId}`);
        set({
            isLoading: true,
            error: undefined,
            channelOwnerId,
            channelId,
        });
        return new Promise((resolve, reject) => {
            channelOperation({
                operation: "listPosts",
                channelOwnerId,
                channelId,
            }, {
                okCallback: (clientDetailCode, data) => {
                    logger.log(LOGPREFIX + `Got channel posts response`);
                    try {
                        const results = JSON.parse(data);
                        const postIds = results.postIds || [];
                        logger.log(LOGPREFIX + `Found ${postIds.length} posts in channel`);
                        set({
                            postIds,
                            isLoading: false,
                            lastLoadTime: Date.now(),
                            error: undefined,
                        });
                        resolve(postIds);
                    }
                    catch (parseError) {
                        const errorMessage = `Error parsing channel posts: ${parseError}`;
                        logger.error(LOGPREFIX + errorMessage);
                        set({
                            isLoading: false,
                            error: errorMessage,
                        });
                        reject(new Error(errorMessage));
                    }
                },
                errorCallback: (clientDetailCode, errorMessage) => {
                    const fullErrorMessage = `Error fetching channel posts: ${errorMessage} (${clientDetailCode})`;
                    logger.error(LOGPREFIX + fullErrorMessage);
                    set({
                        isLoading: false,
                        error: fullErrorMessage,
                    });
                    reject(new Error(fullErrorMessage));
                },
            }, {
                isSignedIn: () => auth.isSignedIn(),
                bearer: () => auth.bearer,
                sequence: () => auth.sequence,
                setBearerAndSequence: (bearer, sequence) => {
                    auth.setBearerAndSequence(bearer, sequence, logger);
                },
                getAuth: () => auth,
            }, cacheBusterStore, logger);
        });
    }),
    // Check if a specific post ID exists in the loaded posts
    hasPostId: (postId) => {
        const { postIds } = get();
        const cleanPostId = postId.replace(".json", "");
        return postIds.some((id) => {
            const cleanId = id.replace(".json", "");
            return cleanId === cleanPostId;
        });
    },
    // Clear posts state
    clearPosts: () => {
        set({
            postIds: [],
            isLoading: false,
            lastLoadTime: 0,
            error: undefined,
            channelOwnerId: undefined,
            channelId: undefined,
        });
    },
    // Set error
    setError: (error) => {
        set({ error });
    },
}));
